module.exports = __webpack_public_path__ + "static/media/unionpay.e80816ad.svg";